import z from 'zod/v4';
import { PropertyDataType, PropertyRefSchema } from '../../properties/index.js';
export var ConnectConnectionStatus;
(function (ConnectConnectionStatus) {
    ConnectConnectionStatus["Active"] = "ACTIVE";
    ConnectConnectionStatus["Paused"] = "PAUSED";
    ConnectConnectionStatus["Disabled"] = "DISABLED";
})(ConnectConnectionStatus || (ConnectConnectionStatus = {}));
export const OfferedPropertyTypeSchema = z.object({
    propertyTypeId: z.uuid(),
    handle: z.string(),
    label: z.string(),
    description: z.string().nullish(),
    type: z.enum(PropertyDataType),
    ref: PropertyRefSchema,
    required: z.boolean(),
});
export const PropertyTypeMappingSchema = z.object({
    ref: PropertyRefSchema,
    fromHandle: z.string(),
    toHandle: z.string(),
});
export const ConnectionOptions = z.object({
    sendInteractions: z.boolean().optional(),
    filterNonContactUsers: z.boolean().optional(),
    alwaysCreateNewCustomer: z.boolean().optional(),
    offeredPropertyTypes: z.array(OfferedPropertyTypeSchema).optional(),
    propertyTypeMappings: z.array(PropertyTypeMappingSchema).optional(),
});
/**
 * A single entry in the receiver's mapping request. The receiver either maps an
 * offered handle onto an existing target handle (`toHandle`), or asks the server
 * to create a matching property type from the offered snapshot and map onto it
 * (`create: true`). Resolving `create` on the server keeps type creation and
 * mapping persistence inside one transaction, so a failure can never leave
 * orphaned property types behind, and a retry never accumulates duplicates.
 */
export const PropertyTypeMappingInputSchema = z
    .object({
    ref: PropertyRefSchema,
    fromHandle: z.string(),
    toHandle: z.string().optional(),
    create: z.boolean().optional(),
})
    .refine((m) => m.create === true || (m.toHandle != null && m.toHandle.length > 0), { message: 'Either toHandle or create must be provided' });
export const PatchConnectionOptionsSchema = z.object({
    propertyTypeMappings: z.array(PropertyTypeMappingInputSchema),
});
export const CreateConnectConnectionSchema = z.object({
    fromTenantId: z.uuid(),
    fromCreditorId: z.uuid().optional(),
    toTenantId: z.uuid(),
    toCreditorId: z.uuid(),
    productId: z.uuid(),
    options: ConnectionOptions.optional(),
});
//# sourceMappingURL=index.js.map